import { HOSPITALITE_KEYS } from "./keys.js";
import { hospitaliteProfile } from "./profile.js";
export const hospitaliteModule = {
    code: "HOSPITALITE",
    profile: hospitaliteProfile,
    moduleKeys: HOSPITALITE_KEYS.map((key) => ({
        key,
        moduleClass: "sector-specific",
    })),
};
export { HOSPITALITE_KEYS } from "./keys.js";
//# sourceMappingURL=index.js.map